import { defineMessages } from 'react-intl';

const scope = 'cb.screens.States';

export default defineMessages({
  emptyMessage: {
    id: `${scope}.emptyMessage`,
    defaultMessage: 'Empty here...',
  },
  noAccessMessage: {
    id: `${scope}.noAccessMessage`,
    defaultMessage: 'Access not granted.',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Oops! Error: {error}',
  },
  initializeErrorMessage: {
    id: `${scope}.initializeErrorMessage`,
    defaultMessage: 'Oops! Something went wrong :( Please log out and try again',
  },
});
